<template>
  <!-- Previous and Next promotion buttons -->
  <v-row v-if="isPromotionOrBlog" class="ma-0 mt-4" justify="space-between">
    <v-btn
      class="primary-font-color text-capitalize my-4"
      justify="end"
      color="primary"
      @click="previousPromotionOrBlog"
      :disabled="isPreviousButtonDisabled"
    >
      <v-icon class="primary-font-color">chevron_left</v-icon>
      {{ previousButtonText }}
    </v-btn>
    <v-btn
      class="primary-font-color text-capitalize my-4"
      justify="end"
      color="primary"
      @click="nextPromotionOrBlog"
      :disabled="isNextButtonDisabled"
    >
      {{ nextButtonText }}
      <v-icon class="primary-font-color">chevron_right</v-icon>
    </v-btn>
  </v-row>
</template>

<script>
export default {
  name: 'EventPreviousNextPromotion',
  props: {
    eventDetails: Object,
  },
  components: {},
  computed: {
    isPreviousButtonDisabled: function () {
      if (this.getPreviousEventId() !== '') {
        return false;
      }
      return true;
    },
    isNextButtonDisabled: function () {
      if (this.getNextEventId() !== '') {
        return false;
      }
      return true;
    },
    isPromotion() {
      return (
        this.componentEventDetails.Type === 'Promotion' ||
        this.componentEventDetails.Type === 'RepeatingPromotion'
      );
    },
    isPromotionOrBlog() {
      return (
        this.componentEventDetails.Type === 'Promotion' ||
        this.componentEventDetails.Type === 'RepeatingPromotion' ||
        this.componentEventDetails.Type === 'BlogEvent'
      );
    },
    previousButtonText() {
      if (this.isPromotion) {
        return this.$translate('PREVIOUS_BUTTON_PROMOTION');
      }
      return this.$translate('PREVIOUS_BUTTON_BLOG');
    },
    nextButtonText() {
      if (this.isPromotion) {
        return this.$translate('NEXT_BUTTON_PROMOTION');
      }
      return this.$translate('NEXT_BUTTON_BLOG');
    },
  },
  data() {
    return {
      componentEventDetails: {},
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    eventDetails() {
      this.init();
    },
  },
  methods: {
    init() {
      this.componentEventDetails = this.eventDetails;
    },
    getPreviousEventId() {
      if (this.isPromotion) {
        const promotions = this.$store.getters['user/promotions'];
        if (promotions.length == 0) {
          console.log('No promotions loaded. Can not get previous promotion.');
          return '';
        }
        for (let i = promotions.length - 1; i >= 0; i--) {
          if (promotions[i].EventId == this.componentEventDetails.EventId) {
            if (i - 1 >= 0) {
              return promotions[i - 1].EventId;
            }
          }
        }
      } else if (this.isPromotionOrBlog) {
        const blogs = this.$store.getters['user/blogs'];
        if (blogs.length == 0) {
          console.log('No blogs loaded. Can not get previous blog.');
          return '';
        }
        for (let i = blogs.length - 1; i >= 0; i--) {
          if (blogs[i].EventId == this.componentEventDetails.EventId) {
            if (i - 1 >= 0) {
              return blogs[i - 1].EventId;
            }
          }
        }
      }
      return '';
    },
    previousPromotionOrBlog() {
      let eventId = this.getPreviousEventId();
      if (eventId !== '') {
        this.$router.push({
          name: 'EventDetails',
          params: { event_id: eventId },
        });
      }
    },
    getNextEventId() {
      if (this.isPromotion) {
        const promotions = this.$store.getters['user/promotions'];
        if (promotions.length == 0) {
          console.log('No promotions loaded. Can not get next promotion.');
          return '';
        }
        for (let i = 0; i < promotions.length; i++) {
          if (promotions[i].EventId == this.componentEventDetails.EventId) {
            if (i + 1 < promotions.length) {
              return promotions[i + 1].EventId;
            }
          }
        }
      } else if (this.isPromotionOrBlog) {
        const blogs = this.$store.getters['user/blogs'];
        if (blogs.length == 0) {
          console.log('No blogs loaded. Can not get next blog.');
          return '';
        }
        for (let i = 0; i < blogs.length; i++) {
          if (blogs[i].EventId == this.componentEventDetails.EventId) {
            if (i + 1 < blogs.length) {
              return blogs[i + 1].EventId;
            }
          }
        }
      }
      return '';
    },
    nextPromotionOrBlog() {
      let eventId = this.getNextEventId();
      if (eventId !== '') {
        this.$router.push({
          name: 'EventDetails',
          params: { event_id: eventId },
        });
      }
    },
  },
};
</script>
